import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';

import * as DataAccessSearchActions from './data-access-search.actions';

import * as DataAccessSearchSelectors from './data-access-search.selectors';

import { SearchFilters, SearchSortOrder, SearchType } from '../../model/search-filter';
import { StringFilter } from '../option-ids-visible/search-filter-options.models';

@Injectable()
export class DataAccessSearchFacade {
  /**
   * Combine pieces of state using createSelector,
   * and expose them as observables through the facade.
   */
  results$ = this.store.pipe(select(DataAccessSearchSelectors.getSearchResults));
  searchFilters$ = this.store.pipe(select(DataAccessSearchSelectors.getSearchFilters));
  searchTypeFilter$ = this.store.pipe(select(DataAccessSearchSelectors.getSearchTypeFilter));
  counts$ = this.store.pipe(select(DataAccessSearchSelectors.getNumberOfSearchResults));
  totalCounts$ = this.store.pipe(select(DataAccessSearchSelectors.getTotalCounts));
  countsBySearchType$ = this.store.pipe(select(DataAccessSearchSelectors.getCounts));
  searchTerm$ = this.store.pipe(select(DataAccessSearchSelectors.getSearchTermFilter));
  suggestedSearchTerm$ = this.store.pipe(select(DataAccessSearchSelectors.getSuggestedSearchTerm));
  loaded$ = this.store.pipe(select(DataAccessSearchSelectors.isLoaded));
  searchFilterModalOpen$ = this.store.pipe(select(DataAccessSearchSelectors.isSearchFilterModalOpen));
  autocompleteSuggestions$ = this.store.pipe(select(DataAccessSearchSelectors.getAutocompleteSuggestions));
  searchResultSuggestions$ = this.store.pipe(select(DataAccessSearchSelectors.getSearchResultSuggestions));

  constructor(private readonly store: Store) {}

  searchPageOpened(filters: SearchFilters) {
    this.store.dispatch(DataAccessSearchActions.searchPageOpened({ filters }));
  }

  searchPageClosed() {
    this.store.dispatch(DataAccessSearchActions.searchPageClosed());
  }

  searchTypeSelected(searchTypes: SearchType[]) {
    this.store.dispatch(DataAccessSearchActions.searchTypeSelected({ searchTypes }));
  }

  searchTermSelected(searchTerm: string) {
    this.store.dispatch(DataAccessSearchActions.searchTermSelected({ searchTerm }));
  }

  searchFilterModalOpened() {
    this.store.dispatch(DataAccessSearchActions.searchFilterModalOpened());
  }

  searchFilterModalClosed() {
    this.store.dispatch(DataAccessSearchActions.searchFilterModalClosed());
  }

  stringFilterChanged(stringFilter: StringFilter) {
    this.store.dispatch(DataAccessSearchActions.stringFilterChanged({ stringFilter }));
  }

  searchPaginationClicked(searchPageIndex: number) {
    this.store.dispatch(DataAccessSearchActions.searchPaginationClicked({ searchPageIndex }));
  }

  searchSortingSelected(searchSortOrder: SearchSortOrder) {
    this.store.dispatch(DataAccessSearchActions.searchSortingSelected({ searchSortOrder }));
  }

  searchFormValueChanged(searchTermFragment: string | null) {
    this.store.dispatch(DataAccessSearchActions.searchFormValueChanged({ searchTermFragment }));
  }

  getSearchResultById(itemId: string) {
    return this.store.pipe(select(DataAccessSearchSelectors.getSearchResultById, { itemId }));
  }

  generateSearchDocument() {
    this.store.dispatch(DataAccessSearchActions.generateSearchDocument());
  }
}
